import { useState, useEffect } from "react";
import { CustomProperty } from "winslow-core";
import { GenericSelect, GenericSelectOption } from "../../shared/GenericSelect";
import { CheckboxMultipleSettings } from "./customPropertyConfig";
import { Check } from "lucide-react";

type AppCustomPropertyCheckboxMultipleProps = {
    customProperty: CustomProperty;
    data: any;
    validate: boolean;
    onChange: (label: string, data: any) => void;
}

export const AppCustomPropertyCheckboxMultiple = ({customProperty, data, validate, onChange} : AppCustomPropertyCheckboxMultipleProps) => {

    const [choices, setChoices] = useState<Map<string, boolean>>(data ? new Map(data.map((choice: string) => [choice, true])) : new Map());

    // useEffect(() => {
    //     if (data) {
    //         const newChoices = new Map<string, boolean>();
    //         data.forEach((choice: string) => {
    //             newChoices.set(choice, true);
    //         });
    //         setChoices(newChoices);
    //     }
    // }, [data]);

    useEffect(() => {    
        const data = Array.from(choices.keys()).filter((key) => choices.get(key));
        onChange(customProperty.label, data);
    }, [choices]);

    const atLeastOneChecked = Array.from(choices.values()).some((value) => value);
    const settings = JSON.parse(customProperty.settings || "{}") as CheckboxMultipleSettings;

    return (
        <div className="app-custom-property-multiple">
            {settings.choices.map((choice: string) => {
                return (
                    <div 
                        key={choice}
                        className="app-custom-property-multiple-choice">
                        <input 
                            type="checkbox"
                            name={customProperty.label}
                            checked={choices.get(choice) || false}
                            onChange={(event) => {
                                const newChoices = new Map(choices);
                                newChoices.set(choice, event.target.checked);
                                setChoices(newChoices);
                            }}
                        />
                        {choice}
                    </div>
                )
                })
            }
            {validate && customProperty.required && !settings.allowNone && !atLeastOneChecked &&
                <div className="app-employee-record-error">
                    <Check size={16} color="red"/>
                </div>
            } 
        </div>
    )
}
